import SupervisingUserDetailPage from "@/app/(app)/(crew)/supervising/[shift]/user/[user]";

export default SupervisingUserDetailPage;
